import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewEditCommonComponent } from '../view-edit-common/view-edit-common.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shared-table',
  templateUrl: './shared-table.component.html',
  styleUrls: ['./shared-table.component.css']
})
export class SharedTableComponent {
  ref: DynamicDialogRef | undefined;
  @Input() columns: any[] = [];
  @Input() data: any[] = [];
  @Input() dropdownOptions: { [key: string]: string[] } = {};
  @Input() triggerDialog: any;
  sortedColumnIndex: number | null = null;
  sortOrder: 'ASC' | 'DESC' = 'ASC';
  selectedRows: any[] = [];  // Array to hold selected rows
  isAllSelected: boolean = false;
  @Output() sortChange: EventEmitter<{ columnKey: string, sortOrder: 'ASC' | 'DESC' }> = new EventEmitter();
  @Output() selectedRowsChange: EventEmitter<any[]> = new EventEmitter();
  @Output() selectedRowsDelete: EventEmitter<any[]> = new EventEmitter();
  showHideColumnDropdown = false;
  sidebarType: any;
  deleteCalenderDetailPopup = false;
  constructor(private dialog: MatDialog, public dialogService: DialogService, private cdr: ChangeDetectorRef,
    public router: Router
  ) { }

  tooltipOptions = {
    showDelay: 150,
    autoHide: false,
    outerHeight: '50px'
};

ngOnInit(): void {
  this.sidebarType = localStorage.getItem('sidebarType')!;
  this.updateTableHeight();
  this.cdr.detectChanges();
}

updateTableHeight() {
  setTimeout(() => {
    const tableElement = document.querySelector(".p-datatable");

    if (!tableElement) return;

    if (this.sidebarType === 'top') {
      tableElement.classList.add("top");
    } else {
      tableElement.classList.remove("top");
    }
  }, 0); // Adjust delay if needed
}

sortApproval(data:any){
 return data.sort((a:any, b:any) => a.sequence - b.sequence);
}

  sortData(columnIndex: number, columnKey: string): void {
    this.sortOrder = this.sortedColumnIndex === columnIndex && this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    this.sortedColumnIndex = columnIndex;

    this.data.sort((a, b) => {
      const valueA = a[columnKey];
      const valueB = b[columnKey];

      console.log(`Sorting by column: ${columnKey} (index: ${columnIndex}), Order: ${this.sortOrder}`);

      // Sorting logic based on the order
      if (valueA < valueB) return this.sortOrder === 'ASC' ? -1 : 1;
      if (valueA > valueB) return this.sortOrder === 'ASC' ? 1 : -1;
      return 0;
    });
    // Emit the sort change event to the parent component
    this.sortChange.emit({ columnKey, sortOrder: this.sortOrder });

    console.log('Sorted Data:', this.data);
  }

  openRowDetailsDialog(column: any, row: any): void {
    if (column) {
      const columnKey = column.key; 
      this.ref = this.dialogService.open(ViewEditCommonComponent, {
        data: {
          rowData: row,
          columns: this.columns,
          triggerDialog: columnKey, 
          printData: true,
        },
        width: '65vw',
        contentStyle: { overflow: 'auto', position: "top" },
        draggable: true
      });
  
      this.ref.onClose.subscribe((result: any) => {
        if (result) {
          console.log('Dialog closed with result:', result);
        }
      });
    } 

    else if (row) {
      const columnKey = this.columns.find(col => col.viewDialog === true)?.key; // Get column with viewDialog: true
      if (columnKey) {
        this.ref = this.dialogService.open(ViewEditCommonComponent, {
          data: {
            rowData: row,
            columns: this.columns.map(col => col.header),
            triggerDialog: columnKey, 
            printData: true,
          },
          width: '65vw',
          contentStyle: { overflow: 'auto', position: "top" },
          draggable: true
        });
  
        this.ref.onClose.subscribe((result: any) => {
          if (result) {
            console.log('Dialog closed with result:', result);
          }
        });
      }
    }
  }
  
  toggleSelectAll() {
    if (this.isAllSelected) {
      this.data.forEach(row => row.selected = true);
      this.selectedRows = [...this.data];
      console.log(this.selectedRows)
    } else {
      this.data.forEach(row => row.selected = false);
      this.selectedRows = [];
    }
    this.selectedRowsChange.emit(this.selectedRows);
  }

  onRowSelect(row: any) {
    if (row) {
      this.selectedRows = []
      this.selectedRows.push(row);
      this.selectedRowsChange.emit(this.selectedRows); 
    }
  }

  onRowDelete(row: any) {
    if (row) {
      this.selectedRows = []
      this.selectedRows.push(row);
      this.deleteCalenderDetailPopup = true;
    }
  }
  
  deleteCalendar(){
    this.deleteCalenderDetailPopup = false;
    this.selectedRowsDelete.emit(this.selectedRows); 
  }

  // onRowSelect(row: any) {
  //   if (row.selected) {
  //     this.selectedRows = this.data.filter(r => r.selected);
  //   } else {
  //     this.selectedRows = this.selectedRows.filter(r => r !== row);
  //   }
  
  //   this.isAllSelected = this.data.every(r => r.selected);
  //   this.selectedRowsChange.emit(this.selectedRows); 
  // }

  exportToCSV(name:any) {
    const visibleColumns = this.columns.filter(col => col.showColumn !== false);
    const headers = visibleColumns.map(col => col.header);

    const rows = this.data.map(row => {
      return visibleColumns.map(col => {
        const value = this.getDisplayValue(col, row);
        return value != null ? value.toString().replace(/"/g, '""') : ''; // Escape quotes for CSV
      });
    });

    let csvContent = headers.join(',') + '\n';
    rows.forEach(row => {
      csvContent += row.map(value => `"${value}"`).join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${name}_export.csv`;
    link.click();
    URL.revokeObjectURL(url);
  }

  private getDisplayValue(column: any, row: any): any {
    let value = row[column.key];

    if (column.type === 'status') {
      return value == 1 ? 'Active' : 'Inactive';
    } else if (column.type === 'userRole') {
      return (value || []).map((wh: any) => wh?.roleDescription).join(', ');
    } else if (column.type === 'warehouse') {
      return (value || []).map((wh: any) => wh?.warehouseId).join(', ');
    } else if (column.type === 'customerwarehouse') {
      return (value || []).map((wh: any) => `${wh?.clientName}-${wh?.warehouseName}`).join(', ');
    } else if (column.type === 'expense') {
      return (value || []).map((wh: any) => wh?.expense).join(', ');
    } else if (column.type === 'revenueAttribute') {
      return (value || []).map((wh: any) => wh?.quickCodeName).join(', ');
    } else if (column.type === 'document') {
      return (value || []).join('; '); // Use semicolon to separate links for CSV
    } else if (column.key === 'approvalHierarchy') {
      const sorted = this.sortApproval(value || []);
      return sorted.map((name: any) => `${name?.sequence} ${name?.designation}`).join('; ');
    } else if (column.type === 'date' || column.type === 'dateOnly' || column.type === 'timeOnly' || column.type === 'month') {
      // Assuming value is already a string or can be stringified; adjust if CustomDatePipe logic is needed
      return value;
    }

    // Default for other types (text, input, dropdown, etc.)
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    return value;
  }
  
}